module.exports = __webpack_public_path__ + "static/fonts/SanFranciscoDisplayRegular.760e6ae.woff2";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/SanFranciscoDisplayRegular.woff2
// module id = vTsl
// module chunks = 1